import type { MenuPermissionsMap, User } from '@/features/auth/types/auth.types';

import type { OpsNavItem } from './opsNav.types';

/**
 * Returns whether the user may see an ops nav item (same rules as sidebar menu filtering).
 * Nếu `menuPermissions` có key trùng `item.menuPermissionKey` hoặc `item.key`, BE quyết định (GET /api/auth/permissions/me).
 */
export function canAccessOpsNavItem(
  user: User | null,
  item: OpsNavItem,
  menuPermissions?: MenuPermissionsMap | null,
): boolean {
  if (!user) return false;
  const permKey = item.menuPermissionKey ?? item.key;
  if (menuPermissions && Object.prototype.hasOwnProperty.call(menuPermissions, permKey)) {
    return menuPermissions[permKey] === true;
  }
  if (item.requiredRoles && !item.requiredRoles.includes(user.role)) {
    return false;
  }
  if (user.role !== 'admin' && item.requiredPermissions?.length) {
    return item.requiredPermissions.some((perm) => user.permissions.includes(perm));
  }
  return true;
}

/**
 * Filters ops navigation items for the current user.
 */
export function filterOpsNav(
  items: OpsNavItem[],
  user: User | null,
  menuPermissions?: MenuPermissionsMap | null,
): OpsNavItem[] {
  return items.filter((item) => canAccessOpsNavItem(user, item, menuPermissions));
}
